import React, { useMemo } from 'react';
import Column from '@bexs/dollar/components/GridColumn';
import { useFormik } from 'formik';
import { useDispatch } from 'react-redux';
import { useSelector } from 'store';
import * as Yup from 'yup';
import { DownloadFormState } from 'pages/Reports/types';
import downloadActions from 'store/ducks/download/actions';
import moment from 'moment';
import Label from '@bexs/dollar/components/Label';
import Datepicker from '@bexs/dollar/components/Datepicker';
import FieldRow from '@bexs/dollar/components/FieldRow';
import Input from '@bexs/dollar/components/Input';
import { PageOverlayLoader } from 'pages/Balance/styles';
import { CustomButton } from 'styles/global';

const Form: React.FC = () => {
  const dispatch = useDispatch();
  const validationSchema = Yup.object({
    downloadDate: Yup.string().required('Date is required'),
  });

  const { isLoading } = useSelector().download;

  const formik = useFormik<DownloadFormState>({
    initialValues: {
      downloadDate: '',
      formattedDate: '',
    },
    validationSchema,
    onSubmit: ({ formattedDate }) => {
      dispatch(
        downloadActions.request({
          periodStart: formattedDate,
        })
      );
    },
    validateOnBlur: false,
  });

  const getDateIsInvalid = useMemo(
    () => !!formik.touched.downloadDate && !!formik.errors.downloadDate,
    [formik.touched.downloadDate, formik.errors.downloadDate]
  );

  const setDateValue = (selectedDates: Date[]) => {
    const [dateValue] = selectedDates;

    const downloadDate = moment(dateValue).format('DD/MM/YYYY');
    const formattedDate = moment(dateValue).format('YYYY-MM-DD');
    formik.setValues({
      formattedDate,
      downloadDate,
    });
  };

  const datepickerInput = useMemo(
    () => (
      <Input
        {...formik.getFieldProps('downloadDate')}
        autoComplete="off"
        id="downloadDate"
        name="downloadDate"
        type="text"
        placeholder="DD/MM/YYYY"
        status={getDateIsInvalid ? 'error' : undefined}
        errorLabel={formik.errors.downloadDate as string}
      />
    ),
    [formik, getDateIsInvalid]
  );

  return (
    <Column>
      <PageOverlayLoader isShowing={isLoading} />
      <form
        onSubmit={formik.handleSubmit}
        autoComplete="off"
        style={{ zIndex: 99, position: 'relative' }}
      >
        <FieldRow style={{ marginTop: '20px' }}>
          <Label htmlFor="downloadDate">Report Date</Label>
          <Datepicker
            numberOfVisibleMonths={2}
            renderInput={() => datepickerInput}
            onSelect={setDateValue}
          />
        </FieldRow>
        <FieldRow>
          <CustomButton variation="primary" type="submit">
            Download
          </CustomButton>
        </FieldRow>
      </form>
    </Column>
  );
};

export default Form;
